import { css } from '@emotion/react'
import { fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const baseStyles = ({
  color,
  name,
  noAccountColor = colors.orange.base,
  size = fontSizes.medium,
  style,
}) =>
  css({
    color: name ? color : noAccountColor,
    fontFamily: fonts.sansSerif,
    fontSize: size,
    ...style,
  })
